import { getMessageFromError } from '../utils/functions'

const COUNTRY_PREFIX = 'country'

export default {
  /* -------------------------------------------------------------------------- */
  /*                     Get Pre Defined Values                                 */
  /* -------------------------------------------------------------------------- */
  async getPreDefinedValues({ commit }, params) {
    commit('SET_STATE', {
      action: 'listLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`admin/pre-defined`, { params })
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      return res.data.data
    } catch (error) {
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                               Admin Predefine                              */
  /* -------------------------------------------------------------------------- */
  async getDropdownCreators({ commit }, data) {
    commit('SET_STATE', {
      action: 'listLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`admin/creator/list?type=dropdown`, { params: data })
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      return res.data
    } catch (error) {
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                               Admin Predefine                              */
  /* -------------------------------------------------------------------------- */
  async getAdminPreDefinedValues({ commit }, data) {
    commit('SET_STATE', {
      action: 'listLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`admin/predefined-value/list?type=${data.type}`)
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      return res.data
    } catch (error) {
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                      Country Options For Dropdown API                     */
  /* -------------------------------------------------------------------------- */
  async getCountries({ commit }, params) {
    commit('SET_STATE', {
      action: 'listLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`${COUNTRY_PREFIX}/country-list`, { params })
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      const data = res.data.data
      const result = data.results.map((c) => ({
        value: c._id,
        label: c.country_name
      }))
      return {
        data: result,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* ---------------------------------------------------------------------------------------------------------------------------- */
  /*                                               Get State For Dropdown API                                              */
  /* ---------------------------------------------------------------------------------------------------------------------------- */

  async getStates({ commit }, params) {
    commit('SET_STATE', {
      action: 'listLoading',
      data: true
    })
    commit('SET_STATE', {
      action: 'StateList',
      data: []
    })
    try {
      const res = await this.$http.get(`${COUNTRY_PREFIX}/state-list`, { params })
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })

      const data = res.data.data
      const result = data.results.map((c) => ({
        value: c._id,
        label: c.name
      }))

      commit('SET_STATE', {
        action: 'StateList',
        data: result
      })

      return {
        data: result,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      commit('SET_STATE', {
        action: 'StateList',
        data: []
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* ---------------------------------------------------------------------------------------------------------------------------- */
  /*                                               Get State For Dropdown API                                              */
  /* ---------------------------------------------------------------------------------------------------------------------------- */

  async getCities({ commit }, params) {
    commit('SET_STATE', {
      action: 'listLoading',
      data: true
    })
    commit('SET_STATE', {
      action: 'CityList',
      data: []
    })
    try {
      const res = await this.$http.get(`${COUNTRY_PREFIX}/city-list`, { params })
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })

      const data = res.data.data
      const result = data.results.map((c) => ({
        value: c._id,
        label: c.name
      }))

      commit('SET_STATE', {
        action: 'CityList',
        data: result
      })

      return {
        data: result,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      commit('SET_STATE', {
        action: 'CityList',
        data: []
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                            Upgrade Refresh Token                           */
  /* -------------------------------------------------------------------------- */
  async upgradeRefreshToken({ commit }, data) {
    commit('SET_STATE', {
      action: 'createLoading',
      data: true
    })
    try {
      const res = await this.$http.post('refresh-token/', data)
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      return {
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      // Manage Error
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                               Forget Password                              */
  /* -------------------------------------------------------------------------- */
  async forgotPassword({ commit }, data) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await this.$http.post('admin/auth/forgot-password', data)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const messages = getMessageFromError(error)
      return Promise.reject(messages)
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                               Reset Password                              */
  /* -------------------------------------------------------------------------- */
  async resetPassword({ commit }, data) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await this.$http.put('admin/auth/reset-password', data)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const messages = getMessageFromError(error)
      return Promise.reject(messages)
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                      Country Options For Dropdown API                     */
  /* -------------------------------------------------------------------------- */
  async getUsers({ commit }, params) {
    commit('SET_STATE', {
      action: 'listLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`admin/user/list`, { params })
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      const data = res.data.data
      const result = data.results.map((v) => {
        const fullName = `${v.first_name || ''} ${v.last_name || ''}`.trim()
        return {
          value: v._id,
          label: fullName || v.handle_name || v.email || 'Unknown user',
          first_name: v.first_name || '',
          last_name: v.last_name || '',
          avatar: v.image,
          email: v.email,
          handle_name: v.handle_name || ''
        }
      })
      return {
        data: result,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  }
}
